import React from 'react';

import Link from '@atlaskit/link/link';

export default function HtmlAttributes(): React.JSX.Element {
	return (
		<Link href="https://www.loom.com" rel="noopener noreferrer" target="_blank">
			Loom home
		</Link>
	);
}
